<template> 
    <iframe
        v-if="iframeSrc"
        :src="iframeSrc"
        width="100%"
        height="680"
        frameborder="0"
        allowfullscreen
      ></iframe>
  </template>
  
  <script>
  export default {
    props: [
      "media",
      "enroll_id",
      "user_id",
      "subject_id",
      "lesson_id",
      "access_token",
      "lesson_status",
      "duration",
      "loading"
    ],
    data() {
      return {
        playSeconds: 0,
        timer: null,
        iframeSrc: null, // เก็บ src ของ iframe
      };
    },
  
    mounted() { 
      //ดึง src จาก media.url (ที่เป็น iframe HTML)
      const match = this.media?.url?.match(/src=["']([^"']+)["']/);
      if (match && match[1]) {
        this.iframeSrc = match[1];
      }
      
        // เริ่มจับเวลาเมื่อ component โหลด
      this.timer = setInterval(() => {
        this.playSeconds++;
        console.log("เวลาที่ component เปิดอยู่:", this.playSeconds, "วินาที");
  
        // ✅ ยิง API ทุก 10 วิ
        if (this.playSeconds % 10 === 0) { 
          this.sendProgress();
        }
      }, 1000); 
      
    },
  
    beforeDestroy() {
      // หยุดจับเวลาเมื่อ component ถูกทำลาย
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      console.log("รวมเวลาที่เปิด component:", this.playSeconds, "วินาที");
    },
  
    methods: {
      async sendProgress() { 
        if (this.lesson_status != 1) {
          const model = {
            user_id: this.user_id,
            subject_id: this.subject_id,
            lesson_id: this.lesson_id,
            lesson_time_sec: this.playSeconds, 
            enroll_id: this.enroll_id,
            duration: this.duration
          };
  
          console.log(model);
          
           
          this.$store
            .dispatch("Lessons/saveLessonH5pProgress", {
              model,
              accessToken: this.access_token,
            })
            .catch((err) => {
              if (err.response.status == 401) {
                this.$store.dispatch("Auth/logout").then(() => {
                  this.$router.push("/login");
                });
              }
            });
        }
      },
    },
  };
  </script>
  